import React, { useEffect, useState } from "react";

/* NYE boarding countdown , auto-targets the NEXT upcoming 31 December at
   7:30pm AEDT. After NYE 2026 passes, the countdown automatically rolls
   forward to NYE 2027, then 2028, etc. , no admin intervention needed.

   AEDT is UTC+11. NYE boarding is 31 Dec at 19:30 local Sydney time. */

function getNextBoardingTarget() {
 const now = new Date();
 // Build this year's NYE boarding date in AEDT (UTC+11)
 let year = now.getUTCFullYear();
 // 31 Dec 19:30 AEDT == 31 Dec 08:30 UTC
 let target = new Date(Date.UTC(year, 11, 31, 8, 30, 0));
 // If we're already past this year's boarding, roll forward to next year
 if (now.getTime() > target.getTime()) {
  target = new Date(Date.UTC(year + 1, 11, 31, 8, 30, 0));
 }
 return target;
}

function getRemaining(targetTime) {
 const diff = Math.max(0, targetTime - Date.now());
 const s = Math.floor(diff / 1000);
 return {
  done: diff === 0,
  days: Math.floor(s / 86400),
  hours: Math.floor((s % 86400) / 3600),
  minutes: Math.floor((s % 3600) / 60),
  seconds: s % 60,
 };
}

const pad = (n) => String(n).padStart(2, "0");

const NYECountdown = ({ gold = "#D4AF37", champagne = "#F5E6C8", testid = "nye-countdown" }) => {
 const [target, setTarget] = useState(() => getNextBoardingTarget());
 const [t, setT] = useState(() => getRemaining(target.getTime()));

 useEffect(() => {
  const id = setInterval(() => {
   const remaining = getRemaining(target.getTime());
   // Once the current target hits zero, refresh to the next year's boarding
   // (small 5-minute grace window so guests see the "Boarding now" state briefly).
   if (remaining.done && (Date.now() - target.getTime()) > 5 * 60 * 1000) {
    const next = getNextBoardingTarget();
    setTarget(next);
    setT(getRemaining(next.getTime()));
   } else {
    setT(remaining);
   }
  }, 1000);
  return () => clearInterval(id);
 }, [target]);

 if (t.done) {
  return (
   <div className="inline-flex items-center gap-3 px-6 py-4 rounded-2xl ring-1 backdrop-blur-md" style={{ borderColor: `${gold}55`, background: `linear-gradient(135deg, ${gold}1A, rgba(10,10,10,0.55))` }} data-testid={`${testid}-live`}>
    <span className="text-white text-sm font-black tracking-[0.24em] uppercase">Boarding now · Happy NYE ✦</span>
   </div>
  );
 }

 const boardingYear = target.getUTCFullYear();
 const welcomeYear = boardingYear + 1;

 const blocks = [
  { label: "Days", val: t.days },
  { label: "Hours", val: t.hours },
  { label: "Minutes", val: t.minutes },
  { label: "Seconds", val: t.seconds },
 ];

 return (
  <div className="flex flex-col items-center gap-3" data-testid={testid}>
   <div className="inline-flex items-center gap-3 text-[10px] sm:text-[11px] uppercase tracking-[0.36em] font-black" style={{ color: gold }}>
    <span className="w-6 sm:w-10 h-px" style={{ backgroundColor: gold, opacity: 0.6 }} />
    Boarding 31 Dec {boardingYear} · 7:30pm
    <span className="w-6 sm:w-10 h-px" style={{ backgroundColor: gold, opacity: 0.6 }} />
   </div>
   <div className="grid grid-cols-4 gap-2.5 sm:gap-4">
    {blocks.map((b, i) => (
     <div
      key={b.label}
      className="rounded-2xl px-3 sm:px-5 py-3 sm:py-4 ring-1 backdrop-blur-md text-center min-w-[72px] sm:min-w-[92px]"
      style={{
       borderColor: `${gold}55`,
       background: `linear-gradient(135deg, ${gold}1A 0%, rgba(10,10,10,0.6) 70%)`,
       boxShadow: `0 18px 40px -18px ${gold}55, inset 0 0 0 1px ${gold}15`,
      }}
      data-testid={`${testid}-${b.label.toLowerCase()}`}
     >
      <div
       className="font-black tabular-nums leading-none"
       style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: "clamp(1.6rem, 3.5vw, 2.6rem)",
        backgroundImage: `linear-gradient(135deg, ${champagne} 0%, ${gold} 100%)`,
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        WebkitTextFillColor: "transparent",
        color: "transparent",
       }}
      >
       {i === 0 ? b.val : pad(b.val)}
      </div>
      <div className="mt-1.5 sm:mt-2 text-[9px] sm:text-[10px] uppercase tracking-[0.24em] font-bold text-white/65">
       {b.label}
      </div>
     </div>
    ))}
   </div>
   <div className="text-white/55 text-[10px] sm:text-[11px] uppercase tracking-[0.28em] font-bold">
    Until we welcome {welcomeYear} · seats selling fast
   </div>
  </div>
 );
};

export default NYECountdown;

